module.exports = __webpack_public_path__ + "files/e0017a48de1bc6a593c18a44cb5a3c10.woff2";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/lora-bold-webfont.woff2
// module id = 693
// module chunks = 60